import React from 'react';
import styles from './Login.scss';
import SupportWidget from 'common/components/SupportWidget/LandingPage';
import { getAppConfig } from '../../util/configUtil';

const LoginLayout = (props) => {

    function getReleaseValue() {
        const { complionEnterpriseRelease } = getAppConfig();
        return complionEnterpriseRelease;
    }

    return (
        <div className={styles.containerNoBg}>

            <div className={styles.loginCardv4}>

                <div className={styles.complionLogov4} ></div>
                {props.children}
                <div className={styles.complionPrivacy}>
                    <a className={styles.complionPrivacyStatement} href="https://complion.com/privacy-policy/">
                        Complion Privacy Statement
                    </a >
                    <div className={styles.complionVersion}>Version: {getReleaseValue()}
                    </div >
                </div >
            </div >
            <SupportWidget />
        </div >

    );
};

export default LoginLayout;